export function getDefaultItemPayload() {
    return {
        itemType: 'STATIC_PAGE_V2',
        itemData: {},
        seoData: {},
        asNewPage: false,
    };
}
